export const campaignDuration = 14
